import React from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import SideNav from '../../shared/Sidenav';
import '../../../css/cancellationPolicy/CancellationPolicy.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import add from '../../../assets/images/add.svg';
import addDisable from '../../../assets/images/plus_disable.svg';
import viewAccess from '../../../assets/images/viewOnlyAccess.svg';
import arrow from '../../../assets/images/drpdwnArrow.svg';
import Input from '../../shared/Input';
import SuccessModal from '../../shared/SuccessModal';
import DeleteModal from '../../shared/DeleteRoleModal';
import DublicateValueModal from '../../shared/DeleteAssignRoleModal';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { hours, minute } from '../../../data/hoursAndMinute';
import message from '../../../data/Message.json';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceDeliveryBaseURL } from '../../../Services/config/apiGateway';
import { PENALTYPOLICY_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
let viewOnly = false;
class CancellationPolicy extends React.Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            addPolicy: false,
            editIndex: '',
            isEdit: [],
            deleteIndex: '',
            cancellationPolicyData: [],
            policySelections: '',
            cancellationPolicyDescription: '',
            cancellationNotificationPeriod: '',
            serviceChargeforRequester: '',
            serviceChargeforRespondent: '',
            tptTransactionFees: '',
            confirmedHasOpen: false,
            hasOpenDelete: false,
            effectiveDateValue: '',
            showEffectiveCalendar: false,
            effectiveDateHourValue: '',
            effectiveDateMinuteValue: '',
            dropDownEffectiveHour: false,
            dropDownEffectiveMinute: false,
            effectiveDateValueArray: [],
            showEffectiveCalendarArray: [false],
            effectiveDateHourValueArray: [],
            effectiveDateMinuteValueArray: [],
            dropDownEffectiveHourArray: [false],
            dropDownEffectiveMinuteArray: [false],
            editCancellationPolicyDescription: [],
            editCancellationNotificationPeriod: [],
            editServiceChargeforRequester: [],
            editServiceChargeforRespondent: [],
            editTPTTransactionFees: [],
            dublicateValueHasOpen: false,
            deleteConfirmedHasOpen: false,
            hh: hours,
            mm: minute,
        }
        this.onAddPolicy = this.onAddPolicy.bind(this);
    }
    validateFormFields = () => {
        return this.state.cancellationPolicyDescription.length > 0 &&
            this.state.policySelections.length > 0 && this.state.cancellationNotificationPeriod && this.state.serviceChargeforRequester && this.state.serviceChargeforRespondent && this.state.tptTransactionFees && this.state.effectiveDateValue.length > 0 && this.state.effectiveDateHourValue !== '' && this.state.effectiveDateMinuteValue !== ''
    };
    validateEditFormFields = () => {
        let validEdit = [];
        let editIndex = this.state.editIndex.filter((element, i) => i === this.state.editIndex.indexOf(element))
        for (let index = 0; index < editIndex.length; index++) {
            const element = editIndex[index];
            if (this.state.isEdit[element]) {
                validEdit = validEdit.concat(this.state.editCancellationPolicyDescription[element].length > 0 && this.state.editCancellationNotificationPeriod[element] !== '' && this.state.editServiceChargeforRequester[element] !== '' && this.state.editServiceChargeforRespondent[element] !== '' && this.state.editTPTTransactionFees[element] !== '')
            }
        }
        return !validEdit.includes(false)
    };

    getDate = (timeStamp) => {
        let date = new Date(timeStamp).toString();
        let day = date.split(' ')[2];
        let month = date.split(' ')[1];
        let year = date.split(' ')[3];
        return `${day}-${month}-${year}`;
    }

    getTime = (timeStamp) => {
        return new Date(timeStamp).toString().split(' ')[4].substring(0, 5)
    }

    onAddPolicy() {
        this.setState({ addPolicy: true });
        document.getElementById('cancellationPolicyTable').scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
    handleAddEffectiveDateChanged = (e) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let formatted_date = e.getDate() + "-" + months[e.getMonth()] + "-" + e.getFullYear();
        if (e.getDate() <= 9) {
            formatted_date = "0" + formatted_date;
        }
        this.setState({ effectiveDateValue: formatted_date, showEffectiveCalendar: false })
        if (e.getDate() == new Date().getDate() && e.getMonth() == new Date().getMonth() && e.getFullYear() == new Date().getFullYear()) {
            let found = this.state.hh.filter((name) => name.hour >= e.getHours())
            this.setState({ hh: found });
        }
        else {
            this.setState({ hh: hours });
        }
    }
    handleEditEffectiveDateChanged = (e, index) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let formatted_date = e.getDate() + "-" + months[e.getMonth()] + "-" + e.getFullYear();
        if (e.getDate() <= 9) {
            formatted_date = "0" + formatted_date;
        }
        let effectiveDateValue = this.state.effectiveDateValueArray;
        effectiveDateValue[index] = formatted_date;
        let showEffectiveCalendar = this.state.showEffectiveCalendarArray;
        showEffectiveCalendar[index] = false;
        this.setState({ effectiveDateValueArray: effectiveDateValue, showEffectiveCalendarArray: showEffectiveCalendar })


        if (e.getDate() == new Date().getDate() && e.getMonth() == new Date().getMonth() && e.getFullYear() == new Date().getFullYear()) {
            let found = this.state.hh.filter((name) => name.hour >= e.getHours())
            this.setState({ hh: found });
        }
        else {
            this.setState({ hh: hours });
        }
    }
    toggleEffectiveCalendar = () => {
        this.setState({
            showEffectiveCalendar: true
        });
    };
    toggleEffectiveHourDropdown = () => {
        this.setState({ dropDownEffectiveHour: !this.state.dropDownEffectiveHour });
    }
    toggleEffectiveMinuteDropdown = () => {
        this.setState({ dropDownEffectiveMinute: !this.state.dropDownEffectiveMinute });
    }
    changeEffectiveHour = (event) => {
        let e = new Date(this.state.effectiveDateValue)
        const found = this.state.hh.find((name) => {
            if (name.hour === event.target.innerText) {
                return name;
            }
        })
        this.setState({ effectiveDateHourValue: found.hour, dropDownEffectiveHour: false });
        if (e.getDate() == new Date().getDate() && e.getMonth() == new Date().getMonth() && e.getFullYear() == new Date().getFullYear() && found.hour == new Date().getHours()) {
            let foundm = this.state.mm.filter((name) => name.m >= new Date().getMinutes())
            console.log(foundm)
            this.setState({ mm: foundm });
        }
        else {
            this.setState({ mm: minute });
        }
    }
    changeEffectiveMinute = (event) => {
        const found = this.state.mm.find((name) => {
            if (name.m === event.target.innerText) {
                return name;
            }
        })
        this.setState({ effectiveDateMinuteValue: found.m, dropDownEffectiveMinute: false });
    }
    changeEditEffectiveHour = (event, index) => {
        let e = new Date(this.state.effectiveDateValueArray[index])
        const found = this.state.hh.find((name) => {
            if (name.hour === event.target.innerText) {
                return name;
            }
        })
        let effectiveDateHourValue = this.state.effectiveDateHourValueArray;
        effectiveDateHourValue[index] = found.hour;
        let dropDownEffectiveHour = this.state.dropDownEffectiveHourArray;
        dropDownEffectiveHour[index] = false;
        this.setState({ effectiveDateHourValueArray: effectiveDateHourValue, dropDownEffectiveHourArray: dropDownEffectiveHour });

        if (e.getDate() == new Date().getDate() && e.getMonth() == new Date().getMonth() && e.getFullYear() == new Date().getFullYear() && found.hour == new Date().getHours()) {
            let foundm = this.state.mm.filter((name) => name.m >= new Date().getMinutes())
            console.log(foundm)
            this.setState({ mm: foundm });
        }
        else {
            this.setState({ mm: minute });
        }
    }
    changeEditEffectiveMinute = (event, index) => {
        const found = this.state.mm.find((name) => {
            if (name.m === event.target.innerText) {
                return name;
            }
        })
        let effectiveDateMinuteValue = this.state.effectiveDateMinuteValueArray;
        effectiveDateMinuteValue[index] = found.m;
        let dropDownEffectiveMinute = this.state.dropDownEffectiveMinuteArray;
        dropDownEffectiveMinute[index] = false;
        this.setState({ effectiveDateMinuteValueArray: effectiveDateMinuteValue, dropDownEffectiveMinuteArray: dropDownEffectiveMinute });
    }
    handleClickOutside = (event) => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            let editIndex = this.state.editIndex.filter((element, i) => i === this.state.editIndex.indexOf(element))
            for (let index = 0; index < editIndex.length; index++) {
                const element = editIndex[index];
                let showEffectiveCalendar = this.state.showEffectiveCalendarArray;
                showEffectiveCalendar[element] = false;
                let dropDownEffectiveHour = this.state.dropDownEffectiveHourArray;
                dropDownEffectiveHour[element] = false;
                let dropDownEffectiveMinute = this.state.dropDownEffectiveMinuteArray;
                dropDownEffectiveMinute[element] = false;
                this.setState({
                    showEffectiveCalendarArray: showEffectiveCalendar,
                    dropDownEffectiveHourArray: dropDownEffectiveHour,
                    dropDownEffectiveMinuteArray: dropDownEffectiveMinute,
                    dropDownEffectiveMinute: false,
                    dropDownEffectiveHour: false,
                    showEffectiveCalendar: false
                })
            }
        }
    }
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);

        var selectedTiles = [];
        let roleData = this.props.data;
        const roleDataLength = roleData.length;
        for (let z = 0; z < roleDataLength; z++) {
            var rd = roleData[z].permissions;
            selectedTiles.push(rd)
        }
        selectedTiles.map(x =>
            x.map(md => {
                if (md.functionId == 24) {
                    if (md.method.includes("View & Edit")) {
                        viewOnly = true
                    }
                }
            }))
        let descriptionArr = [];
        let dateArr = [];
        let hourArr = [];
        let MinuteArr = [];
        let notificationArr = [];
        let requesterArr = [];
        let respondentArr = [];
        let transactionFeeArr = [];
        ApiCall(
            'GET',
            serviceDeliveryBaseURL + PENALTYPOLICY_ENDPOINT,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-cc-trace-id': '1234',
            }
        ).then(data => {
            if (data.flag !== -1) {
                if (data.flag === 500) {
                    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
                else {
                    console.log('I am 200!');
                    data.sort(function (a, b) {
                        return b.penaltyId - a.penaltyId
                    })
                    this.setState({ cancellationPolicyData: data }, () => { console.log(this.state.cancellationPolicyData) })

                    data.map((x, i) => {
                        console.log(x.basePenalty.penaltyDescription)
                        descriptionArr.push(x.basePenalty.penaltyDescription)
                        dateArr.push("26 Jul 2021");
                        hourArr.push("13");
                        MinuteArr.push("30");
                        notificationArr.push(x.basePenalty.notificationPeriod);
                        requesterArr.push(x.basePenalty.requestorServiceCharge);
                        respondentArr.push(x.basePenalty.respondedServiceCharge);
                        transactionFeeArr.push(x.basePenalty.transactionFee);
                        this.setState({
                            editCancellationPolicyDescription: descriptionArr,
                            editCancellationNotificationPeriod: notificationArr,
                            editServiceChargeforRequester: requesterArr,
                            editServiceChargeforRespondent: respondentArr,
                            editTPTTransactionFees: transactionFeeArr,
                            effectiveDateValueArray: dateArr,
                            effectiveDateHourValueArray: hourArr,
                            effectiveDateMinuteValueArray: MinuteArr
                        })
                    })
                }
            }
            else {
                //    toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        })
    }
    handlePolicySelections = (e) => {
        let value = e.target.value;
        value = value.replace(/[^a-zA-Z ]/gi, '');
        this.setState({ policySelections: value })
    }
    handleCancellationPolicyDescription = (e) => {
        this.setState({ cancellationPolicyDescription: e.target.value })
    }
    handleCancellationNotificationPeriod = (e) => {
        let value = e.target.value;
        value = value.replace(/[^0-9\.]/gi, "");
        this.setState({ cancellationNotificationPeriod: value })
    }
    handleServiceChargeforRequester = (e) => {
        let value = e.target.value;
        value = value.replace(/[^0-9\.]/gi, "");
        this.setState({ serviceChargeforRequester: value })
    }
    handleServiceChargeforRespondent = (e) => {
        let value = e.target.value;
        value = value.replace(/[^0-9\.]/gi, "");
        this.setState({ serviceChargeforRespondent: value })
    }
    handleTPTTransactionFees = (e) => {
        let value = e.target.value;
        value = value.replace(/[^0-9\.]/gi, "");
        this.setState({ tptTransactionFees: value })
    }
    deleteAddPolicy = () => {
        this.setState({
            policySelections: '',
            cancellationPolicyDescription: '',
            cancellationNotificationPeriod: '',
            serviceChargeforRequester: '',
            serviceChargeforRespondent: '',
            tptTransactionFees: '',
            addPolicy: false
        })
    }
    manageCancellationPolicyDescription = (description) => {
        let element;
        let descriptionArray = [];
        for (let index = 0; index < description.length; index++) {
            if (index <= 50) {
                element = description[index];
                descriptionArray.push(element)
            }
        }
        return descriptionArray.join("") + "..."
    }
    onDeleteCancellationPolicy = (index) => {
        this.setState({ deleteIndex: index, hasOpenDelete: true })
    }
    onCloseDeleteModal = () => {
        this.setState({ hasOpenDelete: false });
    }
    onSaveCancellationPolicy = () => {
        console.log(this.state.cancellationPolicyData)
        let fromTimeStamp = (new Date(this.state.effectiveDateValue)).toString().substring(4, 15) + ' ' + this.state.effectiveDateHourValue + ':' + this.state.effectiveDateMinuteValue;
        if (this.state.isEdit.length > 0) {
            ApiCall(
                'PUT',
                serviceDeliveryBaseURL + PENALTYPOLICY_ENDPOINT,
                this.onSaveEditData(),

                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'x-cc-trace-id': '1234',
                }
            ).then(apiData => {
                if (apiData.flag !== -1) {
                    if (apiData.flag === 500) {
                        toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                    }
                    else {
                        console.log('I am 200!');
                        this.setState({ confirmedHasOpen: true });
                    }

                }
                else {
                    //    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
            })
        }
        else {
            if (this.state.cancellationPolicyData.find(e => (e.basePenalty.penaltyName.trim() == this.state.policySelections.trim() || e.basePenalty.penaltyName.trim().toUpperCase() == this.state.policySelections.trim() || e.basePenalty.penaltyName.trim().toLowerCase() == this.state.policySelections))) {
                this.setState({ dublicateValueHasOpen: true });
            }
            else {
                ApiCall(
                    'POST',
                    serviceDeliveryBaseURL + PENALTYPOLICY_ENDPOINT,
                    {
                        "penaltyName": this.state.policySelections,
                        "penaltyDescription": this.state.cancellationPolicyDescription,
                        "notificationPeriod": this.state.cancellationNotificationPeriod,
                        "requestorServiceCharge": this.state.serviceChargeforRequester,
                        "respondedServiceCharge": this.state.serviceChargeforRespondent,
                        "transactionFee": this.state.tptTransactionFees,
                        "effectiveFrom": Date.parse(fromTimeStamp),
                        "expiryDate": 0,
                    },
                    {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'x-cc-trace-id': '1234',

                    }
                ).then(data => {
                    if (data.flag !== -1) {
                        if (data.flag === 500) {
                            toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                        }
                        else {
                            console.log('I am 200!');
                            this.setState({ confirmedHasOpen: true });
                        }
                    }
                    else {
                        //    toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
                    }
                })
            }
        }
    }
    onCloseDublicateValueModal = () => {
        this.setState({ dublicateValueHasOpen: false });
    }
    onCloseConfirmed = () => {
        this.setState({ confirmedHasOpen: false });
        window.location.reload();
    }
    onCloseDeleteConfirmed = () => {
        this.setState({ deleteConfirmedHasOpen: false });
        window.location.reload();
    }
    confirmDelete = () => {
        ApiCall(
            'DELETE',
            serviceDeliveryBaseURL + PENALTYPOLICY_ENDPOINT + `?penaltyId=${this.state.cancellationPolicyData[this.state.deleteIndex].penaltyId}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-cc-trace-id': '1234',
            },
        ).then((apiData) => {
            if (apiData.flag !== -1) {
                if (apiData.flag === 500) {
                    // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
                }
                else {
                    console.log('I am 200!');
                    console.log(apiData.message);
                    this.setState({ deleteConfirmedHasOpen: true });
                    this.setState({ hasOpenDelete: false });
                }
            } else {
                // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        });
    }
    onHandleEditDescription = (e, index) => {
        let deacription = this.state.editCancellationPolicyDescription;
        deacription[index] = e.target.value;
        this.setState({ editCancellationPolicyDescription: deacription })
    }
    onHandleNotification = (e, index) => {
        let value = e.target.value;
        value = value.replace(/[^0-9\.]/gi, "");
        let notification = this.state.editCancellationNotificationPeriod;
        notification[index] = value;
        this.setState({ editCancellationNotificationPeriod: notification })
    }
    onHandleEditRequester = (e, index) => {
        let value = e.target.value;
        value = value.replace(/[^0-9\.]/gi, "");
        let requester = this.state.editServiceChargeforRequester;
        requester[index] = value;
        this.setState({ editServiceChargeforRequester: requester })
    }
    onHandleEditRespondent = (e, index) => {
        let value = e.target.value;
        value = value.replace(/[^0-9\.]/gi, "");
        let respondent = this.state.editServiceChargeforRespondent;
        respondent[index] = value;
        this.setState({ editServiceChargeforRespondent: respondent })
    }
    onHandleEditTransactionFee = (e, index) => {
        let value = e.target.value;
        value = value.replace(/[^0-9\.]/gi, "");
        let transactionFee = this.state.editTPTTransactionFees;
        transactionFee[index] = value;
        this.setState({ editTPTTransactionFees: transactionFee })
    }
    onSaveEditData = () => {
        let editedCancellationPolicy = [];
        let editIndex = this.state.editIndex.filter((element, i) => i === this.state.editIndex.indexOf(element))
        for (let index = 0; index < editIndex.length; index++) {
            const element = editIndex[index];
            let fromTimeStamp = new Date(this.state.effectiveDateValueArray[element]).toString().substring(4, 15) + ' ' + this.state.effectiveDateHourValueArray[element] + ':' + this.state.effectiveDateMinuteValueArray[element];
            if (this.state.isEdit[element]) {
                editedCancellationPolicy.push({
                    penaltyId: this.state.cancellationPolicyData[element].penaltyId,
                    basePenalty: {
                        penaltyName: this.state.cancellationPolicyData[element].basePenalty.penaltyName,
                        penaltyDescription: this.state.editCancellationPolicyDescription[element],
                        notificationPeriod: this.state.editCancellationNotificationPeriod[element],
                        requestorServiceCharge: this.state.editServiceChargeforRequester[element],
                        respondedServiceCharge: this.state.editServiceChargeforRespondent[element],
                        transactionFee: this.state.editTPTTransactionFees[element],
                        effectiveFrom: Date.parse(fromTimeStamp)
                    }
                })
            }
        }
        return editedCancellationPolicy;
    }
    renderTableHeader() {
        return (
            <>
                <tr class="bg-white" id="tableHeader">
                    <td id="cancellationPolicySNo" className="cancellationPolicyTableHeading">S. No.</td>
                    <td id="headingPolicySelections" className="cancellationPolicyTableHeading">Policy Selections</td>
                    <td id="headingCancellationPolicyDescription" className="cancellationPolicyTableHeading">Cancellation Policy Description</td>
                    <td id="headingCancellationPolicyDescription" className="cancellationPolicyTableHeading">Effective Date & Time</td>
                    <td id="headingCancellationNotificationPeriod" className="cancellationPolicyTableHeading">Cancellation Notification Period (Hrs{" >"})</td>
                    <td id="headingServiceChargeforRequester" className="cancellationPolicyTableHeading">Service Charge for Requester (%)</td>
                    <td id="headingServiceChargeforRespondent" className="cancellationPolicyTableHeading">Service Charge for Respondent (%)</td>
                    <td id="headingTPTTransactionFees" className="cancellationPolicyTableHeading">TPT Transaction Fees (%)</td>
                    <td className="cancellationPolicyTableHeading" id="extraHeadingTd" style={{ display: !viewOnly ? "none" : null }}></td>
                </tr>
            </>
        )
    }


    render() {

        const renderTableData = this.state.cancellationPolicyData.map((basePenalty, index) => {
            let todo = basePenalty.basePenalty;
            return (
                <>
                    {(!this.state.isEdit[index]) ?
                        <tr key={index} id="cancellationPolicyData" >
                            <td id="cancellationPolicySNo" className="cancellationPolicytabledata">{index + 1}</td>
                            <td id="headingPolicySelections" className="cancellationPolicytabledata">{todo.penaltyName}</td>
                            <td id="headingCancellationPolicyDescription" className="cancellationPolicytabledata">
                                <div data-tip={todo.penaltyDescription}>{todo.penaltyDescription.length > 50 ? this.manageCancellationPolicyDescription(todo.penaltyDescription) : todo.penaltyDescription}</div>
                                <ReactTooltip place="bottom" effect='solid' arrowColor="#6F6F6F" backgroundColor="#6F6F6F" multiline={true} className="serviceDescriptionReactTooltip" />
                            </td>
                            <td className="cancellationPolicytabledata">
                                {this.getDate(todo.effectiveFrom)} &nbsp;&nbsp;&nbsp;&nbsp;{this.getTime(todo.effectiveFrom)}
                            </td>
                            <td id="headingCancellationNotificationPeriod" className="cancellationPolicytabledata">{todo.notificationPeriod}</td>
                            <td id="headingServiceChargeforRequester" className="cancellationPolicytabledata">{todo.requestorServiceCharge}</td>
                            <td id="headingServiceChargeforRespondent" className="cancellationPolicytabledata">{todo.respondedServiceCharge}</td>
                            <td id="headingTPTTransactionFees" className="cancellationPolicytabledata">{todo.transactionFee}</td>
                            <td style={{ display: !viewOnly ? "none" : null }} className="extraBodyTd">
                                <div>

                                    <img
                                        src={(this.state.isEdit[index]) ? require('../../../assets/images/editenable.svg') : require('../../../assets/images/edit.svg')}
                                        width="26" height="26" alt="" loading="lazy"
                                        class="editimagetablefuntion"
                                        id="cancellationPolicyEditIcon"
                                        onClick={() => {
                                            let a = this.state.isEdit;
                                            a[index] = !this.state.isEdit[index];
                                            let x = [...this.state.editIndex];
                                            x.push(index)
                                            this.setState({ isEdit: a, editIndex: x });
                                        }}
                                    />
                                    <img
                                        src={require('../../../assets/images/delete_enable.svg')}
                                        width="26" height="26" alt="" loading="lazy"
                                        class="editimagetablefuntion"
                                        onClick={() => this.onDeleteCancellationPolicy(index)}
                                    />
                                </div>
                            </td>

                        </tr>
                        :
                        <tr className="addPolicyRow"

                            id="cancellationPolicyData"
                        >
                            <td
                                className="cancellationPolicytabledata"
                                id="cancellationPolicySNo">{index + 1}</td>
                            <td
                                className="cancellationPolicytabledata"
                                id="headingPolicySelections">
                                {todo.penaltyName}
                            </td>
                            <td className="cancellationPolicyTD" id="headingCancellationPolicyDescription">
                                <textarea id="cancellationPolicyDescription" className="tabledata"
                                    maxLength="200"
                                    value={this.state.editCancellationPolicyDescription[index]}
                                    onChange={(e) => this.onHandleEditDescription(e, index)}
                                >
                                </textarea>
                            </td>
                            <td className="cancellationPolicyTD" >
                                <div class="cancellationPolicyDateRow">
                                    <div class="cancellationPolicyDateInput">
                                        <Input class="cancellationPolicyInputBox" placeholder="Select Date"
                                            value={this.state.effectiveDateValueArray[index]}
                                        />
                                    </div>

                                    <div class="cancellationPolicyCalender">  {this.state.showEffectiveCalendarArray[index] ? <div
                                        ref={this.container}
                                    > <Calendar
                                            onChange={(e) => this.handleEditEffectiveDateChanged(e, index)}
                                            minDate={new Date()} /></div> : null}</div>
                                    <img src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block mr-4" alt="" loading="lazy" onClick={() => {
                                        let showEffectiveCalendar = this.state.showEffectiveCalendarArray;
                                        showEffectiveCalendar[index] = !this.state.showEffectiveCalendarArray[index];
                                        this.setState({ showEffectiveCalendarArray: showEffectiveCalendar })
                                    }}
                                    />
                                    <div class="cancellationPolicyHourMinuteDiv">
                                        <input class="cancellationPolicyInputBox" placeholder="HH" value={this.state.effectiveDateHourValueArray[index]}></input>
                                    </div>

                                    <img class="pl-2 pr-2" src={arrow} alt="Second slide"
                                        onClick={() => {
                                            let dropDownEffectiveHour = this.state.dropDownEffectiveHourArray;
                                            dropDownEffectiveHour[index] = !this.state.dropDownEffectiveHourArray[index];
                                            this.setState({ dropDownEffectiveHourArray: dropDownEffectiveHour })
                                        }}
                                    />
                                    <div>
                                        {this.state.dropDownEffectiveHourArray[index] && (
                                            <div class="border" id="cancellationPolicyHourDropdown"
                                                ref={this.container}
                                            >
                                                {
                                                    this.state.hh.map((datah, indexh) => {
                                                        return (
                                                            <table class="cancellationPolicyHourHover">
                                                                <tr onClick={(index1) => this.changeEditEffectiveHour(index1, index)}>
                                                                    <small class="hourMinuteText">{datah.hour}</small>
                                                                </tr>
                                                            </table>
                                                        )
                                                    }
                                                    )}
                                            </div>
                                        )}</div>
                                    <div class="cancellationPolicyHourMinuteDiv">
                                        <input class="cancellationPolicyInputBox" placeholder="MM" value={this.state.effectiveDateMinuteValueArray[index]}></input>
                                    </div>
                                    <img class="pl-2 pr-2" src={arrow} alt="Second slide"
                                        onClick={() => {
                                            let dropDownEffectiveMinute = this.state.dropDownEffectiveMinuteArray;
                                            dropDownEffectiveMinute[index] = !this.state.dropDownEffectiveMinuteArray[index];
                                            this.setState({ dropDownEffectiveMinuteArray: dropDownEffectiveMinute })
                                        }}
                                    />
                                    <div>
                                        {this.state.dropDownEffectiveMinuteArray[index] && (
                                            <div class="border" id="cancellationPolicyMinuteDropdown"
                                                ref={this.container}
                                            >
                                                {
                                                    this.state.mm.map((datam, indexh) => {
                                                        return (
                                                            <table class="cancellationPolicyHourHover">
                                                                <tr onClick={(index1) => this.changeEditEffectiveMinute(index1, index)}>
                                                                    <small class="hourMinuteText">{datam.m}</small>
                                                                </tr>
                                                            </table>
                                                        )
                                                    }
                                                    )}
                                            </div>
                                        )}</div>
                                </div>

                            </td>
                            <td className="cancellationPolicyTD" id="headingCancellationNotificationPeriod">
                                <input id="cancellationNotificationPeriod" className="tabledata"
                                    value={this.state.editCancellationNotificationPeriod[index]}
                                    onChange={(e) => this.onHandleNotification(e, index)}
                                >
                                </input>
                            </td>
                            <td className="cancellationPolicyTD" id="headingServiceChargeforRequester">
                                <input id="serviceChargeforRequester" className="tabledata"
                                    value={this.state.editServiceChargeforRequester[index]}
                                    onChange={(e) => this.onHandleEditRequester(e, index)}
                                >
                                </input>
                            </td>
                            <td className="cancellationPolicyTD" id="headingServiceChargeforRespondent">
                                <input id="serviceChargeforRespondent" className="tabledata"
                                    value={this.state.editServiceChargeforRespondent[index]}
                                    onChange={(e) => this.onHandleEditRespondent(e, index)}
                                >
                                </input>
                            </td>
                            <td className="cancellationPolicyTD" id="headingTPTTransactionFees">
                                <input id="tptTransactionFees" className="tabledata"
                                    value={this.state.editTPTTransactionFees[index]}
                                    onChange={(e) => this.onHandleEditTransactionFee(e, index)}
                                >
                                </input>
                            </td>
                            <td className="extraBodyTd">
                                <div>
                                    <img
                                        src={(this.state.isEdit[index]) ? require('../../../assets/images/cross.svg') : require('../../../assets/images/edit.svg')}
                                        width="26" height="26" alt="" loading="lazy"
                                        class="editimagetablefuntion"
                                        onClick={() => {
                                            let a = this.state.isEdit;
                                            a[index] = !this.state.isEdit[index];
                                            this.setState({ isEdit: a });
                                        }}
                                    />
                                    <img
                                        src={require('../../../assets/images/delete_enable.svg')}
                                        width="26" height="26" class="editimagetablefuntion" alt="" loading="lazy"
                                    />
                                </div>
                            </td>
                        </tr>}
                </>
            )
        });
        return (
            <div className="outer1"><div className="outer1" id="outerdiv">
                <MetaDecorator title={TitleDescription.cancellationPolicyPageTitle} description={TitleDescription.cancellationPolicyPageDescription} />
                <div className="cancellationPolicyContainer" >
                    <SideNav />
                    <div id="cancellationPolicyPart">
                        <h1 id='cancellationPolicyHeadingTitle'>Cancellation Policy</h1>
                        {/* View Only Access */}
                        <div className="viewOnlyDiv" style={{ display: !viewOnly ? null : "none" }}>
                            <img alt="View Only Access" src={viewAccess} />
                            <span className="viewOnly">View Only Access</span>
                        </div>
                        <div className="contentbox">
                            <div id="cancellationPolicyTable">
                                <table id='cancellationPolicyDetails' >
                                    <thead>
                                        {this.renderTableHeader()}
                                    </thead>
                                    <tbody>
                                        {this.state.addPolicy === true &&
                                            <tr
                                                id="cancellationPolicyData"
                                            >
                                                <td className="extraTD" id="cancellationPolicySNo"></td>
                                                <td className="cancellationPolicyTD" id="headingPolicySelections">
                                                    <input id="policySelections" className="tabledata" type="text" value={this.state.policySelections} onChange={this.handlePolicySelections} />
                                                </td>
                                                <td className="cancellationPolicyTD" id="headingCancellationPolicyDescription">
                                                    <textarea id="cancellationPolicyDescription" className="tabledata" type="text" value={this.state.cancellationPolicyDescription} onChange={this.handleCancellationPolicyDescription} maxLength="200">
                                                    </textarea>
                                                </td>
                                                <td className="cancellationPolicyTD" >
                                                    <div class="cancellationPolicyDateRow">
                                                        <div class="cancellationPolicyDateInput">
                                                            <Input class="cancellationPolicyInputBox" placeholder="Select Date"
                                                                value={this.state.effectiveDateValue}
                                                            />
                                                        </div>
                                                        <div class="cancellationPolicyCalender">  {this.state.showEffectiveCalendar ? <div
                                                            ref={this.container}
                                                        > <Calendar onChange={this.handleAddEffectiveDateChanged} minDate={new Date()} /></div> : null}</div>
                                                        <img src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block mr-4" alt="" loading="lazy" onClick={this.toggleEffectiveCalendar}
                                                        />
                                                        <div class="cancellationPolicyHourMinuteDiv">
                                                            <input class="cancellationPolicyInputBox" placeholder="HH" value={this.state.effectiveDateHourValue}></input>
                                                        </div>
                                                        <img class="pl-2 pr-2" src={arrow} alt="Second slide" onClick={this.toggleEffectiveHourDropdown} />
                                                        <div>
                                                            {this.state.dropDownEffectiveHour && (
                                                                <div class="border" id="cancellationPolicyHourDropdown"
                                                                    ref={this.container}
                                                                >
                                                                    {
                                                                        this.state.hh.map((datah, indexh) => {
                                                                            return (
                                                                                <table class="cancellationPolicyHourHover">
                                                                                    <tr onClick={(index1) => this.changeEffectiveHour(index1)}>
                                                                                        <small class="hourMinuteText">{datah.hour}</small>
                                                                                    </tr>
                                                                                </table>
                                                                            )
                                                                        }
                                                                        )}
                                                                </div>
                                                            )}</div>
                                                        <div class="cancellationPolicyHourMinuteDiv">
                                                            <input class="cancellationPolicyInputBox" placeholder="MM" value={this.state.effectiveDateMinuteValue}></input>
                                                        </div>
                                                        <img class="pl-2 pr-2" src={arrow} alt="Second slide" onClick={this.toggleEffectiveMinuteDropdown} />
                                                        <div>
                                                            {this.state.dropDownEffectiveMinute && (
                                                                <div class="border" id="cancellationPolicyMinuteDropdown"
                                                                    ref={this.container}
                                                                >
                                                                    {
                                                                        this.state.mm.map((datam, indexh) => {
                                                                            return (
                                                                                <table class="cancellationPolicyHourHover">
                                                                                    <tr onClick={(index1) => this.changeEffectiveMinute(index1)}>
                                                                                        <small class="hourMinuteText">{datam.m}</small>
                                                                                    </tr>
                                                                                </table>
                                                                            )
                                                                        }
                                                                        )}
                                                                </div>
                                                            )}</div>
                                                    </div>
                                                </td>
                                                <td className="cancellationPolicyTD" id="headingCancellationNotificationPeriod">
                                                    <input id="cancellationNotificationPeriod" className="tabledata" type="text" value={this.state.cancellationNotificationPeriod} onChange={this.handleCancellationNotificationPeriod}>
                                                    </input>
                                                </td>
                                                <td className="cancellationPolicyTD" id="headingServiceChargeforRequester">
                                                    <input id="serviceChargeforRequester" className="tabledata" type="text" value={this.state.serviceChargeforRequester} onChange={this.handleServiceChargeforRequester}>
                                                    </input>
                                                </td>
                                                <td className="cancellationPolicyTD" id="headingServiceChargeforRespondent">
                                                    <input id="serviceChargeforRespondent" className="tabledata" type="text" value={this.state.serviceChargeforRespondent} onChange={this.handleServiceChargeforRespondent}>
                                                    </input>
                                                </td>
                                                <td className="cancellationPolicyTD" id="headingTPTTransactionFees">
                                                    <input id="tptTransactionFees" className="tabledata" type="text" value={this.state.tptTransactionFees} onChange={this.handleTPTTransactionFees}>
                                                    </input>
                                                </td>
                                                <td className="extraBodyTd"
                                                >
                                                    <div>
                                                        <img
                                                            src={require('../../../assets/images/editenable.svg')}
                                                            width="26" height="26" alt="" loading="lazy"
                                                            class="editimagetablefuntion"
                                                            id="cancellationPolicyEditIcon"
                                                        />
                                                        <img
                                                            src={require('../../../assets/images/delete_enable.svg')}
                                                            width="26" height="26" class="editimagetablefuntion" alt="" loading="lazy"
                                                            onClick={this.deleteAddPolicy}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        }
                                        {renderTableData}
                                    </tbody>
                                </table>
                            </div>
                            <hr className="policyFooterHr" />
                            <div id="cancellationPolicytableFooter">
                                <div>
                                    <div id="addPolicyDiv" style={{ display: !viewOnly ? "none" : null }}>
                                        <Link onClick={this.onAddPolicy} to="#cancellationPolicyData"><img src={this.state.addPolicy ? addDisable : add} alt="" width="19" height="19" id="cancellationPolicyAddIcon" /> <small className="addPolicyText" style={{ color: this.state.addPolicy ? "#B6B6B6" : "#428BCA" }}>Add Policy</small></Link>
                                    </div>
                                    <div className="cancellationPolicyNotes">
                                        <div>
                                            <small className="cancellationPolicyNoteText">Note:</small>
                                        </div>
                                        <div>
                                            <small className="cancellationPolicyNoteData">1. Condition prior to Service which qualifies for a full or partial refund.</small>
                                        </div>

                                        <div>
                                            <small className="cancellationPolicyNoteData">2. Any new policy added here will be visible to Requesters and Respondents on CC.</small>
                                        </div>
                                        <div>
                                            <small className="cancellationPolicyNoteData">3. Only description would be visible to Requesters and Respondents against cancellation policy on CC.</small>
                                        </div>
                                    </div>
                                </div>
                                <div class="savebtndiv" style={{ display: !viewOnly ? "none" : null }}>
                                    <button class="confirmfunctionbtn" disabled={this.state.isEdit.includes(true) ? !this.validateEditFormFields() : !this.validateFormFields()} onClick={this.onSaveCancellationPolicy}>
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <SuccessModal hasOpen={this.state.confirmedHasOpen} onClick={this.onCloseConfirmed}>
                    <p className="confirmedText">New Policy created successfully</p>
                </SuccessModal>
                <SuccessModal hasOpen={this.state.deleteConfirmedHasOpen} onClick={this.onCloseDeleteConfirmed}>
                    <p className="confirmedText">Confirmed</p>
                </SuccessModal>
                <DeleteModal hasOpen={this.state.hasOpenDelete} onClick={this.onCloseDeleteModal} onYesClick={this.confirmDelete} >
                    <p className="deletemodalText">Do you really want to delete this cancellation policy?</p>
                </DeleteModal>
                <DublicateValueModal hasOpen={this.state.dublicateValueHasOpen} onClick={this.onCloseDublicateValueModal}>
                    <div className="outerTextDiv" id="sameRoleDiv">
                        <p id="addrolerespp1">Policy Selection already exits. </p>
                        <p id="addrolerespp2" >Please enter new Policy Selection. </p>
                    </div>
                </DublicateValueModal>
            </div></div>
        )
    }
}
function mapStateToProps(state) {
    return { data: state.adminRoleReducer.roleData }
}
export default connect(mapStateToProps)(CancellationPolicy);